import { cn } from "@/lib/utils";
import { isProductionEnvironment } from "@/lib/environment";
import { useEnvironment } from "@/hooks/useEnvironment";

export function EnvironmentBorder({ children }: { children: React.ReactNode }) {
  const { data, isPending, isError } = useEnvironment();

  const showBorder = !isPending && !isError && data;
  const prod = showBorder && isProductionEnvironment(data);

  const ariaLabel = showBorder
    ? prod
      ? `Production environment: ${data}. Changes may affect live data.`
      : `Non-production environment: ${data}`
    : undefined;

  const title = showBorder
    ? prod
      ? "You are connected to production. Changes may affect live data."
      : "Non-production environment"
    : undefined;

  return (
    <>
      {children}
      {showBorder && (
        <div
          className={cn(
            "pointer-events-none fixed inset-0 z-[100] box-border rounded-xl border-4",
            prod
              ? "border-red-600 dark:border-red-500"
              : "border-green-600 dark:border-green-500",
          )}
          role="status"
          aria-live="polite"
          aria-label={ariaLabel}
          title={title}
        />
      )}
    </>
  );
}
